import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-subtitle-1 font-weight-bold mb-2" }, "Cég adatok", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-subtitle-1 font-weight-bold mb-2" }, " Adminisztrátor adatok ", -1)

import AuthLayout from "@/components/layout/AuthLayout.vue";
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import { InvitationService } from "@/services/InvitationService";


export default /*#__PURE__*/_defineComponent({
  __name: 'RegisterView',
  setup(__props) {

const route = useRoute();
const invitationService = new InvitationService();

const token = route.query.token as string;
const tokenError = ref(false);
const errorMessage = ref("");
const successMessage = ref("");
const loading = ref(false);
const showPassword = ref(false);
const formRef = ref<{ validate: () => Promise<{ valid: boolean }> } | null>(
  null
);

const rules = {
  required: (v: string) => !!v?.trim() || "Kötelező mező",
  email: (v: string) => /.+@.+\..+/.test(v) || "Érvényes email cím szükséges",
  optionalEmail: (v: string) =>
    !v || /.+@.+\..+/.test(v) || "Érvényes email cím szükséges",
  minPassword: (v: string) =>
    v?.length >= 8 || "A jelszónak legalább 8 karakter hosszúnak kell lennie",
  passwordMatch: (v: string) =>
    v === form.value.adminPassword || "A jelszavak nem egyeznek",
};

const form = ref({
  companyName: "",
  address: "",
  phone: "",
  email: "",
  taxNumber: "",
  bankAccount: "",
  bankName: "",
  billingAddress: "",
  adminFirstName: "",
  adminLastName: "",
  adminEmail: "",
  adminPassword: "",
  adminPasswordConfirm: "",
});

onMounted(async () => {
  if (!token) {
    tokenError.value = true;
    return;
  }
  try {
    await invitationService.validateToken(token);
  } catch {
    tokenError.value = true;
  }
});

const onSubmit = async () => {
  const { valid } = await formRef.value!.validate();
  if (!valid) return;

  errorMessage.value = "";
  loading.value = true;
  try {
    await invitationService.register({ token, ...form.value });
    successMessage.value =
      "Sikeres regisztráció! Kérjük, erősítse meg email címét a beküldött levélben található linkre kattintva.";
  } catch (e) {
    if (e?.response?.status === 409) {
      errorMessage.value =
        "Ez az email cím már regisztrálva van a rendszerben.";
    } else {
      errorMessage.value = "A regisztráció sikertelen. Kérjük, próbálja újra.";
    }
  } finally {
    loading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(AuthLayout, { "max-width": 640 }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "mb-4" }, {
        default: _withCtx(() => [
          _createTextVNode("Cég regisztráció")
        ]),
        _: 1
      }),
      (tokenError.value)
        ? (_openBlock(), _createBlock(_component_v_alert, {
            key: 0,
            type: "error",
            variant: "tonal",
            class: "mb-4"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Ez a meghívó link érvénytelen vagy már felhasználták. ")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (successMessage.value)
        ? (_openBlock(), _createBlock(_component_v_alert, {
            key: 1,
            type: "success",
            variant: "tonal",
            class: "mb-4"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(successMessage.value), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!tokenError.value && !successMessage.value)
        ? (_openBlock(), _createBlock(_component_v_form, {
            key: 2,
            ref_key: "formRef",
            ref: formRef,
            onSubmit: _withModifiers(onSubmit, ["prevent"])
          }, {
            default: _withCtx(() => [
              (errorMessage.value)
                ? (_openBlock(), _createBlock(_component_v_alert, {
                    key: 0,
                    type: "error",
                    variant: "tonal",
                    class: "mb-4"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(errorMessage.value), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _hoisted_1,
              _createVNode(_component_v_text_field, {
                modelValue: form.value.companyName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.companyName) = $event)),
                label: "Cégnév",
                variant: "outlined",
                density: "compact",
                class: "mb-2",
                rules: [rules.required]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                modelValue: form.value.address,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.address) = $event)),
                label: "Cím",
                variant: "outlined",
                density: "compact",
                class: "mb-2"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_text_field, {
                modelValue: form.value.phone,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.phone) = $event)),
                label: "Telefonszám",
                variant: "outlined",
                density: "compact",
                class: "mb-2"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_text_field, {
                modelValue: form.value.email,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.email) = $event)),
                label: "Cég email",
                variant: "outlined",
                density: "compact",
                class: "mb-2",
                rules: [rules.optionalEmail]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                modelValue: form.value.taxNumber,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.taxNumber) = $event)),
                label: "Adószám",
                variant: "outlined",
                density: "compact",
                class: "mb-2"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_text_field, {
                modelValue: form.value.bankAccount,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.bankAccount) = $event)),
                label: "Bankszámlaszám",
                variant: "outlined",
                density: "compact",
                class: "mb-2"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_text_field, {
                modelValue: form.value.bankName,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.bankName) = $event)),
                label: "Bank neve",
                variant: "outlined",
                density: "compact",
                class: "mb-2"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_text_field, {
                modelValue: form.value.billingAddress,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.value.billingAddress) = $event)),
                label: "Számlázási cím",
                variant: "outlined",
                density: "compact",
                class: "mb-4"
              }, null, 8, ["modelValue"]),
              _hoisted_2,
              _createVNode(_component_v_text_field, {
                modelValue: form.value.adminLastName,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.value.adminLastName) = $event)),
                label: "Vezetéknév",
                variant: "outlined",
                density: "compact",
                class: "mb-2",
                rules: [rules.required]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                modelValue: form.value.adminFirstName,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.value.adminFirstName) = $event)),
                label: "Keresztnév",
                variant: "outlined",
                density: "compact",
                class: "mb-2",
                rules: [rules.required]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                modelValue: form.value.adminEmail,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.value.adminEmail) = $event)),
                label: "Email",
                variant: "outlined",
                density: "compact",
                class: "mb-2",
                rules: [rules.required, rules.email]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                modelValue: form.value.adminPassword,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.value.adminPassword) = $event)),
                label: "Jelszó",
                type: showPassword.value ? 'text' : 'password',
                "append-inner-icon": showPassword.value ? 'mdi-eye-off' : 'mdi-eye',
                variant: "outlined",
                density: "compact",
                class: "mb-2",
                rules: [rules.required, rules.minPassword],
                "onClick:appendInner": _cache[12] || (_cache[12] = ($event: any) => (showPassword.value = !showPassword.value))
              }, null, 8, ["modelValue", "type", "append-inner-icon", "rules"]),
              _createVNode(_component_v_text_field, {
                modelValue: form.value.adminPasswordConfirm,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((form.value.adminPasswordConfirm) = $event)),
                label: "Jelszó megerősítése",
                type: showPassword.value ? 'text' : 'password',
                variant: "outlined",
                density: "compact",
                class: "mb-4",
                rules: [rules.required, rules.passwordMatch]
              }, null, 8, ["modelValue", "type", "rules"]),
              _createVNode(_component_v_btn, {
                type: "submit",
                color: "primary",
                size: "large",
                block: "",
                loading: loading.value,
                disabled: loading.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Regisztráció ")
                ]),
                _: 1
              }, 8, ["loading", "disabled"])
            ]),
            _: 1
          }, 512))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})